import {Injectable} from '@angular/core';
import {JSEncrypt} from 'jsencrypt';
import {environment} from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class CryptoService {

  private publicKey = environment.key.public;
  private privateKey = environment.key.private;
  private keySize = environment.key.size;

  constructor() {
  }

  encrypt(value): string {
    const encrypt = new JSEncrypt({default_key_size: this.keySize});
    encrypt.setPublicKey(this.publicKey);
    const encrypted = encrypt.encrypt(btoa(value));
    return typeof encrypted === 'string' ? encrypted : '';
  }

  decrypt(value): string {
    const decrypt = new JSEncrypt({default_key_size: this.keySize});
    decrypt.setPrivateKey(this.privateKey);
    const decrypted = decrypt.decrypt(value);
    return typeof decrypted === 'string' ? atob(decrypted) : '';
  }

}
